@charset "UTF-8";

/* src/app/app.component.scss */
.app-root {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--surface-primary);
  color: var(--text-primary);
}
.app-root.with-shell ::ng-deep app-header {
  display: none;
}
.app-root.with-shell ::ng-deep app-home-footer {
  display: none;
}
.app-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: clip;
}
.version {
  position: absolute;
  bottom: 4px;
  right: 4px;
  margin: 0;
  color: #ccc;
  font-size: 0.9rem;
}
.redirect-screen {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: var(--crwd-safe-top, 0px) var(--crwd-safe-right, 0px) var(--crwd-safe-bottom, 0px) var(--crwd-safe-left, 0px);
  background: var(--background-color, #fff);
  color: var(--text-secondary, #6b7280);
}
.redirect-screen__dots {
  display: flex;
  gap: 0.5rem;
}
.redirect-screen__dots span {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 9999px;
  background: rgba(128, 128, 128, 0.85);
  animation: redirect-typing 1.2s ease-in-out infinite;
}
.redirect-screen__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.redirect-screen__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.redirect-screen__label {
  margin: 0;
  max-width: min(22rem, 100vw - 3rem);
  text-align: center;
  font-size: 0.875rem;
}
@keyframes redirect-typing {
  0%, 60%, 100% {
    opacity: 0.25;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-0.25rem);
  }
}
@media (prefers-reduced-motion: reduce) {
  .redirect-screen__dots span {
    animation: none;
    opacity: 0.6;
  }
}
/*# sourceMappingURL=app.component-L3LH74UG.css.map */
